import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useDispatch } from "react-redux";
import { Label } from "reactstrap";
import { useForm } from "react-hook-form";
import {
  createService,
  getServiceById,
  updateService,
} from "../../../../store/slices/servicesSlice";
import { getAllPrograms } from "../../../../store/slices/programsSlice";
import { useSelector } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Select from "react-select";
import CreatetableSelect from "react-select/creatable";
import UploadComponent from "../../Components/uploadComponent";
const NewServiceForm = forwardRef((props, ref) => {
  const { formType, toggle, pagination } = props;
  const dispatch = useDispatch();
  const [formFields, setFormFields] = useState({
    name: "",
    description: "",
    program_id: "",
    type: "grouped",
  });
  const [file, setFile] = useState(null);

  const serviceDetails = useSelector((state) => state.services.serviceDetail);
  const allServices = useSelector((state) => state.services.allServices).map(
    (service) => ({ label: service?.name, value: service.ID })
  );

  const {
    register,
    trigger,
    formState: { errors },
    setValue,
  } = useForm({ defaultValues: { name: "", description: "" } });
  const [formFieldsValidation, setFormFieldsValidation] = useState({
    role_value: {
      ...register("name", { required: "This field is required" }),
    },
    description: {
      ...register("description", { required: "This field is required" }),
    },
    program_id: {
      ...register("program_id", { required: "This field is required" }),
    },
    type: {
      ...register("type", { required: "This field is required" }),
    },
  });

    const [typeOfBenefit, setTypeOfBenfefit] = useState([
    { value: "grouped", label: "Grouped" },
    { value: "individual", label: "Individual" },
  ]);

  const allPrograms = useSelector(
    (state) => state.programs.allProgramsData
  ).map((program) => ({
    label: program.name,
    value: program.ID,
  }));

  useEffect(() => {
    fetchAllPrograms();
    if (formType === "edit") {
      init();
    }
  }, []);

  useImperativeHandle(ref, () => ({
    async handleSubmit() {
      let isValid = await trigger();
      if (isValid) {
        if (formType === "edit") {
          dispatch(
            updateService({
              ...formFields,
              program_id: formFields?.program_id?.value,
              pagination: pagination,
            })
          );
        } else {
          let payload = formFields;
          if (formFields?.name?.__isNew__) {
            payload = {
              ...payload,
              isNew: true,
              name: payload?.name.label,
            };
          } else {
            payload = {
              service_id: formFields?.name?.value,
            };
          }
          if (file) {
            let formData = new FormData();
            formData.append("file", file);
            formData.append("program_id", formFields?.program_id?.value);
            formData.append("pagination", pagination);
            Object.keys(payload).forEach((key) => {
              formData.append(key, payload[key]);
            });
            dispatch(createService(formData));
          } else {
            dispatch(
              createService({
                ...payload,
                program_id: formFields?.program_id?.value,
                pagination: pagination,
              })
            );
          }
          toggle();
        }
      }
    },
  }));

  const handleInput = (event, field) => {
    console.log(event, field);

    let value;
    if (field === "name") {
      value = event;
    } else if (field === "description") {
      value = event;
    } else if (field === "program_id") {
      value = event;
    } else if(field === "type"){
      setValue("type", event.value);
      setFormFields({ ...formFields, type: event.value });
    }
    else {
      value = event.target.value;
    }

    setValue(field, value);
    setFormFields({ ...formFields, [field]: value });
  };

  const init = () => {
    console.log(serviceDetails, "service details");
    dispatch(getServiceById(serviceDetails.ID));

    Object.keys(serviceDetails).forEach((key) => {
      if (key === "program_id") {
        setValue(key, {
          label: serviceDetails["Program"]?.name,
          value: serviceDetails["Program"]?.ID,
        });
      } else {
        setValue(key, serviceDetails[key]);
      }
    });
    setFormFields({
      ID: serviceDetails.ID,
      name: serviceDetails.name,
      description: serviceDetails.description,
      program_id: {
        label: serviceDetails["Program"]?.name,
        value: serviceDetails["Program"]?.ID,
      },
    });
  };

  const fetchAllPrograms = () => {
    dispatch(getAllPrograms());
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];

  return (
    <div className="px-2">
      <div>
        <Label>Select Program</Label>
        <Select
          options={allPrograms}
          value={formFields.program_id}
          className="js-example-basic-single col-sm-12"
          {...formFieldsValidation.program_id}
          onChange={(event) => handleInput(event, "program_id")}
        />
        {errors.program_id && (
          <span className="mt-1 text-danger">{errors.program_id.message}</span>
        )}
      </div>
      <div className="mt-4">
        <Label>Service Name</Label>

        <CreatetableSelect
          options={allServices}
          onChange={(event) => handleInput(event, "name")}
          isClearable
        />
        {errors.name && (
          <span className="mt-1 text-danger">{errors.name.message}</span>
        )}
      </div>
      <div className="mt-4">
        <Label>Service Description</Label>
        <ReactQuill
          theme="snow"
          modules={modules}
          formats={formats}
          value={formFields.description}
          onChange={(event) => handleInput(event, "description")}
        />

        {errors.description && (
          <span className="mt-1 text-danger">{errors.description.message}</span>
        )}
      </div>
      <div className="mt-4">
                  <Label>Select Benefit Type</Label>
                 <CreatetableSelect
                        options={typeOfBenefit}
                        onChange={(event) => handleInput(event, "type")}
                        value={typeOfBenefit.find((x) => x.value === formFields.type)}
                      />
                  {errors.name && (
                    <span className="mt-1 text-danger">{errors.name.message}</span>
                  )}
                </div>
      <div className="mt-4">
        <UploadComponent addFile={setFile} />
      </div>
    </div>
  );
});

export default NewServiceForm;
